import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public service: AmbitService) { }

  ngOnInit() {
  }

}
